module.exports = __webpack_public_path__ + "img/usdt-new.d923c768.png";